import { useAct } from 'DashboardUser/store'
import Loading from 'Shared/components/Loading'
import './PageContainer.scoped.scss'

import DashboardTargetTable from './DashboardTargetTable'
import DashboardInstructions from './DashboardInstructions'
import { RingroundSnackbar } from 'Shared/components'

export default function PageContainer({ dashboardId }) {
  const act = useAct()
  useEffect(() => {
    if (!dashboardId) return

    act.app.load(dashboardId)
    act.app.loadMe()
  }, [dashboardId])

  const name = useSel(s => s.dashboard.name)
  const loaded = useSel(s => s.app.loaded)
  const { firstName } = useSel(s => s.app.currentUser)

  return <div className='dashboard-user-root'>
    <RingroundSnackbar />
    <div className='topbar'>
      <div className='back'>
        <a href='/'>
          <SvgIconsBackCaret />
          Back
        </a>
      </div>
      <div className='titles'>
        <h1>Hello, { firstName }! 👋</h1>
        <h2>Welcome to { name }</h2>
      </div>
    </div>

    <DashboardInstructions />
    <div className='content'>
      { loaded ? <DashboardTargetTable /> : <Loading /> }
    </div>
  </div>
}
